import type { AllGroup } from '../../types/GroupsArrayType';
import type { RowType } from '../../types/RowType';
import type { OptionsFilterType } from '../../types';
import { RowEventCountProp } from '../makeRows';

import getUserRows from './getUserRows';

type Config = {
  eventHeight: number;
  hideEmptyRows: boolean;
  eventsCountProp: RowEventCountProp;
  rowIds: { [key in string]: boolean };
  eventNumberOfLines: number;
  optionsFilter: OptionsFilterType;
};

export default function makeUserRows(group: AllGroup, config: Config): Array<RowType> {
  const rows = [];
  const { hideEmptyRows, eventsCountProp } = config;
  group.usersArray.forEach((user) => {
    if (hideEmptyRows && !user[eventsCountProp]) {
      return;
    }

    rows.push(...getUserRows(user, group, config));
  });

  return rows;
}
